import { Button } from '@/common/ui/button'
import { useQueryState } from 'nuqs'

interface DataTableProcessorSelectorProps {
	options: { label: string; value: string }[]
	label: string
	paramKey: string
}

export function DataTableProcessorSelector({
	options,
	label,
	paramKey,
}: DataTableProcessorSelectorProps) {
	const [value, setValue] = useQueryState(paramKey, {
		shallow: true,
		defaultValue: '',
	})

	const handleClick = (clickedValue: string) => {
		setValue(clickedValue === value ? '' : clickedValue)
	}

	return (
		<div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-4">
			<label className="text-sm font-medium sm:whitespace-nowrap">
				{label}:
			</label>
			<div className="flex flex-wrap gap-2">
				{options.map((option) => (
					<Button
						key={option.value}
						variant={
							(option.value === '' && value === '') || value === option.value
								? 'default'
								: 'outline'
						}
						onClick={() => handleClick(option.value)}
						className="h-8 px-3 text-xs sm:text-sm"
						size="sm"
					>
						{option.label}
					</Button>
				))}
			</div>
		</div>
	)
}
